import { SomethingWentWrong } from 'components/ErrorPage/SomethingWentWrong';
import { FormWrapper } from 'components/Form/FormWrapper';
import { PartnerContactConfirmation } from 'components/IntegrationServices/PartnerContactConfirmation';
import { onRequestClose } from 'components/NestedRoute/NestedModals';
import type { ReferencedEntry } from 'contentful';
import { PartnerContactForm } from '../IntegrationServices/PartnerContactForm';

import type { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import React, { useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { getField, isEntry } from 'utils/EntryUtil';
import { ModalHeader } from 'components/Modal/Header/ModalHeader';

interface IPartnerContactWrapperProps extends RouteComponentProps {
  entry?: ReferencedEntry<Subject>;
  modalBaseUrl?: string;
}

const PartnerContactWrapper: React.FC<IPartnerContactWrapperProps> = ({
  entry,
  history,
  match,
  modalBaseUrl,
}) => {
  const [errorSubmittingForm, setErrorSubmittingForm] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  if (!isEntry(entry) || !history || !history.location) {
    return null;
  }

  const partner = getField(entry, 'title') || '';

  if (errorSubmittingForm) {
    return (
      <>
        <ModalHeader onCloseButtonClick={() => onRequestClose(history, match)} />
        <SomethingWentWrong isContactForm />
      </>
    );
  }

  if (isFormSubmitted) {
    return (
      <PartnerContactConfirmation partner={partner} onRequestClose={() => onRequestClose(history, match)} />
    );
  }

  return (
    <FormWrapper>
      <PartnerContactForm
        partner={partner}
        onSuccess={() => setIsFormSubmitted(true)}
        onError={() => setErrorSubmittingForm(true)}
        onRequestClose={() => onRequestClose(history, match, modalBaseUrl)}
      />
    </FormWrapper>
  );
};

const WithRouter = withRouter(PartnerContactWrapper);

export { WithRouter as PartnerContactWrapper };
